import { makeAutoObservable } from 'mobx';
import { Col } from '../components/reports/ReportDetailOrg';
import apiConfig from '../api/routes';
import { MembersDataI, MembersDataListType, SelectableDivisionsListItem } from '../types';
import i18next from 'i18next';
import { notification, NotificationType } from '@iba-team/portal-react-components/dist';

class ReportSector {
  constructor() {
    makeAutoObservable(this);
  }
  isReportDownloading = false;
  memberData: MembersDataI = {
    headDivision: {
      hierarchyId: 0,
      hierarchyName: '',
      hierarchyPath: ''
    }, list: [], totalDaysUsedPercentage: 0
  };

  memberColumns: Record<string,string|number>[] = [];
  memberElement: MembersDataListType[] = [];
  headers: Col[] = [];

  fetchHeaders = async () => {
    this.headers = await apiConfig.reportService.getMemberHeaders();
  };

  downloadReport = async (payload: SelectableDivisionsListItem) => {
    let res;
    this.isReportDownloading = true;
    try{
      notification.open({
        type: NotificationType.INFO,
        description: i18next.t('MSG0016'),
      });
      res = await apiConfig.reportService.downloadSectorReportData(payload);
      this.isReportDownloading = true;
    }
    catch (e) {
      this.isReportDownloading = false;
    }
    finally {
      this.isReportDownloading = false;
    }
    return res;
  };

  fetchData = async (year: number) => {
    const res =  await apiConfig.reportService.getMemberData(year);
    this.memberData.headDivision = res.headDivision;
    this.memberData.totalDaysUsedPercentage = res.totalDaysUsedPercentage;
    this.memberElement = res.list;
    this.memberColumns = res.list.map((item, key)=> ({...item.columns,0 :item.columns[1], 1: key+1,}));
  };

}

export const ReportSectorStore = new ReportSector();
